export function getZendeskUrl(lang: string): string {
  switch (lang) {
    case "de":
      return "https://helpcenter.mybeppo.ch/hc/de/requests/new";
    case "fr":
      return "https://helpcenter.mybeppo.ch/hc/fr/requests/new";
    case "it":
      return "https://helpcenter.mybeppo.ch/hc/it/requests/new";
    default:
      return "https://helpcenter.mybeppo.ch/hc/en-ch/requests/new";
  }
}
